import type { WarmupWeekdayCompletion } from '../dal/warmup-dal'

export type WarmupWeekday =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday'

export const getWeekdayFromDate = (date: Date): WarmupWeekday => {
  const dayIndex = date.getDay()
  if (dayIndex === 0) return 'sunday'
  if (dayIndex === 1) return 'monday'
  if (dayIndex === 2) return 'tuesday'
  if (dayIndex === 3) return 'wednesday'
  if (dayIndex === 4) return 'thursday'
  if (dayIndex === 5) return 'friday'
  return 'saturday'
}

const getCompletedWeekdays = (
  completion: WarmupWeekdayCompletion,
): WarmupWeekday[] => {
  const weekdays: WarmupWeekday[] = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ]
  return weekdays.filter((weekday) => completion[weekday])
}

export const getCompletedWeekdaysFromApiCompletion = (
  completion: WarmupWeekdayCompletion | null,
): WarmupWeekday[] => {
  if (completion == null) {
    return []
  }

  return getCompletedWeekdays(completion)
}

export const isDailyWarmupCompletedOnApi = ({
  apiCompletion,
  date = new Date(),
}: {
  apiCompletion: WarmupWeekdayCompletion | null
  date?: Date
}): boolean => {
  if (apiCompletion == null) {
    return false
  }

  const weekday = getWeekdayFromDate(date)
  return apiCompletion[weekday]
}
